import HttpService from "../baseHttp";

// 获取面单信息-分页条件查询
export const HttpSfpList = (data = {}) => HttpService.get("/api/v2/orderPackage/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 面单详情
export const HttpSfp = (data = {}) => HttpService.get("/api/v2/orderPackage/findOne", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 面单编辑保存
export const HttpUpdateSfp = (data = {}, config) => HttpService.post('/api/v2/orderPackage/saveOne', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 选中导出
// export const HttpDownloadSfps = (data = {}) =>HttpService.get("/api/v2/orderPackage/exportorderPackage", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS});

// 批量提交/取消
export const HttpUpdateSfpStatus = (data = {}) => HttpService.get("/api/v2/orderPackage/changeStatus", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 编辑页中运费测算
export const HttpCalculateSfp = (data = {}, config) => HttpService.post('/api/v2/orderPackage/infoCalculation', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_BOSS, params: { contextId: global.SYSID } });

// 订单运费测算
export const HttpCalculateSfps = (data = {}) => HttpService.get('/api/v2/orderPackage/aloneCalculation', { params:data, baseURL: process.env.VUE_APP_APIURL_BOSS});

// 详情页异常-重试
export const HttpRetrySfp = (data = {}) => HttpService.get("/api/v2/orderPackage/retry", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 详情页异常-强制重推
export const HttpforceRetrySfp = (data = {}) => HttpService.get("/api/v2/orderPackage/forcePush", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

//详情页异常-忽略
export const HttpIgnoreSfp = (data = {}) => HttpService.get("/api/v2/orderPackage/ignore", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

//批量补单
export const HttpAppendSfp = (data = {}) => HttpService.get("/api/v2/orderPackage/additionalSheet", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 追踪tracking
export const HttpSfpTrackingNo = (data = {}) => HttpService.get("/api/v2/orderPackage/track", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 非sfp-分页条件查询
export const HttpOtherSfpList = (data = {}) => HttpService.get("/api/v2/orderPackage/findOrderByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 非sfp-重试
export const HttpOtherRetrySfp = (data = {}) => HttpService.get("/api/v2/orderPackage/rePush", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 非sfp 自发货异常-忽略
export const HttpOtherIgnoreSfp = (data = {}) => HttpService.get("/api/v2/orderPackage/orderIgnore", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 非sfp订单日志查询
export const HttpOtherSfpLog = (data = {}) => HttpService.get("/api/v2/orderPackage/findSfpOrderLog", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 动态获取erpsku
export const HttpGetDynamicErpsku = (data = {}) => HttpService.get("/api/v2/ProductDynamicMatching/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });
// 失效，删除，恢复
export const HttpinActiveErpsku = (data = {}) => HttpService.get("/api/v2/ProductDynamicMatching/inActive", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });
export const HttpDeleteErpsku = (data = {}) => HttpService.get("/api/v2/ProductDynamicMatching/del", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });
export const HttpRecoverErpsku = (data = {}) => HttpService.get("/api/v2/ProductDynamicMatching/recover", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });
// 单条查询、提交
export const HttpGetOneErpsku = (data = {}) => HttpService.get("/api/v2/ProductDynamicMatching/findById", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });
export const HttpSaveOneErpsku = (data = {}, config) => HttpService.post('/api/v2/ProductDynamicMatching/save', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_BOSS, params: { contextId: global.SYSID } });

// wayfail
// 查询列表
export const HttpWayfailList = (data = {}) => HttpService.get("/api/v2/dropShipOrderPackage/findByPage", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });
// 批量购买/取消、补单、提交异常
export const HttpUpdateWayfailStatus = (data = {}) => HttpService.get("/api/v2/dropShipOrderPackage/changeStatus", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 重新购买
export const HttpRebuyWayfair = (data = {}) => HttpService.get("/api/v2/dropShipOrderPackage/reBuy", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });


export const HttpAppendWayfail = (data = {}) => HttpService.get("/api/v2/dropShipOrderPackage/additionalSheet", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

export const HttpsetErrorWayfail = (data = {}) => HttpService.get("/api/v2/dropShipOrderPackage/setError", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });
//详情页异常-忽略（列表单个忽略）
export const HttpIgnoreWayfail = (data = {}) => HttpService.get("/api/v2/dropShipOrderPackage/ignore", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 详情页异常-重试
export const HttpRetryWayfail = (data = {}) => HttpService.get("/api/v2/dropShipOrderPackage/retry", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 详情页异常-强制重推
export const HttpforceRetryWayfail = (data = {}) => HttpService.get("/api/v2/dropShipOrderPackage/forcePush", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 查看详情
export const HttpWayfail = (data = {}) => HttpService.get("/api/v2/dropShipOrderPackage/findOne", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

// wayfail面单编辑保存
export const HttpUpdateWayfail = (data = {}, config) => HttpService.post('/api/v2/dropShipOrderPackage/saveOne', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_BOSS });

// 追踪tracking
export const HttpWayfailTrackingNo = (data = {}) => HttpService.get("/api/v2/dropShipOrderPackage/track", { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS });

